// extracted by mini-css-extract-plugin
export default {"cancelNotification":"_143-Y","inModal":"IrcNp","canceledIcon":"_3a1bU"};